// extracted by mini-css-extract-plugin
export default {"container":"MyComputerWindow_container__2tlS1","contentArea":"MyComputerWindow_contentArea__+T9Dw"};